import { CircularProgress, IconButton, ThemeProvider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import CountdownTimer from './components/Helpers/Time/CountdownTimer';
import { getTokenRemainingTime } from './auth';
import Theme from './components/Theme/Theme';
import { useHistory } from 'react-router-dom';

export default function SessionTimeout(props) {

  const { extendSessionCallback } = props;

  const history = useHistory();
  const [modalActive, setModalActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const allowSessionExtension = useRef(true);

  let lastCheckTime = 0;
  let checkFrequencyMS = 1000 * 60 * 1;


  const userActivityEvents = [
    'click',
    'keypress',
    'load',
    'focus',
    'keydown',
  ];

  useEffect(() => {
    // configure listener events 
    userActivityEvents.forEach(event => {
      window.addEventListener(event, sessionTimeout);
    });
  }, []);

  const notifyEventRef = useRef(null);
  useEffect(() => {
    if (props.token) {
      if (notifyEventRef.current) {
        clearTimeout(notifyEventRef.current);
      }
      const notifyTimeMS = 1000 * (getTokenRemainingTime() - 5 * 60); // notify 5 min prior to timeout
      notifyEventRef.current = setTimeout(() => {
        setModalActive(true);
        allowSessionExtension.current = false;
      }, notifyTimeMS);
    }

    // Cleanup on unmount or token change
    return () => {
      if (notifyEventRef.current) {
        clearTimeout(notifyEventRef.current);
      }
    };
  }, [props.token]);

  const sessionTimeout = () => {
    if ((lastCheckTime >= Date.now() - checkFrequencyMS) || !allowSessionExtension.current) {
      return;
    }

    lastCheckTime = Date.now();

    extendTimeout();
  };

  const logOut = () => window.location.href = '/ns';

  const extendTimeout = async () => {
    setLoading(true);

    try {
      await extendSessionCallback();
      setModalActive(false);
      setLoading(false);
      allowSessionExtension.current = true;
    }
    catch (err) {
      setModalActive(false);
      console.log(err);
    }
  };

  const theme = Theme.get();

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Modal className="insured-info-content" show={modalActive} animation={false} backdrop="static" onHide={() => setModalActive(false)} centered>
          <Modal.Body className="d-flex align-items-center justify-content-center p-3 flex-column">
            <div className="head-close">
              <IconButton className="close-button" aria-label="close" onClick={() => setModalActive(false)}>
                <CloseIcon />
              </IconButton>
            </div>
            <p className="pb-4 pt-2 text-center insured-info">Your session is about to Expire. If you do not extend your session within 5 minutes, any unsaved progress will be lost.</p>
            <CountdownTimer initialMinute={5} onTimerComplete={() => logOut()} />
            {
              loading ? <CircularProgress className="circular-progress" /> :
                <Button className="text-center px-4 w-25"
                  variant="contained"
                  size="medium"
                  color="primary"
                  onClick={() => extendTimeout()}
                >
                  Extend
                </Button>
            }
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </ThemeProvider>
  );
}

SessionTimeout.propTypes = {
  extendSessionCallback: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/SessionTimeout.js